module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-header02@2x.4e90dce0.jpg";